import { Link, useNavigate, useParams } from "react-router-dom"
import DashboardSideBar from "../../components/dashboardSidebar"
import Footer from "../../components/footer"
import Header from "../../components/header"
import SideBar from "../../components/sidebar"
import { useState, useEffect } from "react"
import services from "../../services"
import Toaster from "../../components/toaster";
import moment from 'moment'
import useIsMobile from "../../hooks/useIsMobile";
import MobileHeader from "../../components/MobileHeader";

const EditSubscription = () => {
    let navigate = useNavigate();
    const isMobileView = useIsMobile();
    const { id } = useParams();
    const [subscriptionData, setSubscriptionData] = useState({
        startDate: '',
        endDate: '',
        totalCost: '',
        modeOfPayment: '',
        isActive: true
    })
    const [toaster, setToaster] = useState({ visiblity: "hide" });
    const [loading, setLoading] = useState(false)
    const [fetching, setFetching] = useState(true)

    const getSubscriptionDetails = async () => {
        setFetching(true)
        try {
            const response = await services.Vendor.GET_VENDOR_SUBSCRIPTION_BY_ID(id);
            const data = response.data;
            setSubscriptionData({
                startDate: moment(data.startDate).format('YYYY-MM-DD'),
                endDate: moment(data.endDate).format('YYYY-MM-DD'),
                totalCost: data.totalCost,
                modeOfPayment: data.modeOfPayment || '',
                isActive: data.isActive
            })
        } catch (error) {
            console.log(error)
            setToaster({
                type: "danger",
                title: "Error Occured",
                text: error.response?.data?.message || "Failed to fetch subscription details",
                visiblity: "show",
            });
            setTimeout(() => {
                setToaster({ visiblity: "hide" });
            }, 1500)
        } finally {
            setFetching(false)
        }
    }

    useEffect(() => {
        if (id) {
            getSubscriptionDetails()
        }
    }, [id])

    const HandleOnChangeValue = (value, key) => {
        setSubscriptionData({
            ...subscriptionData,
            [key]: value
        })
    }

    const onSubmitHandler = async () => {
        // Validation
        if (!subscriptionData.startDate) {
            setToaster({
                type: "danger",
                title: "Validation Error",
                text: "Start Date is required",
                visiblity: "show",
            });
            setTimeout(() => {
                setToaster({ visiblity: "hide" });
            }, 1500)
            return;
        }
        if (!subscriptionData.endDate) {
            setToaster({
                type: "danger",
                title: "Validation Error",
                text: "End Date is required",
                visiblity: "show",
            });
            setTimeout(() => {
                setToaster({ visiblity: "hide" });
            }, 1500)
            return;
        }
        if (!subscriptionData.totalCost || subscriptionData.totalCost <= 0) {
            setToaster({
                type: "danger",
                title: "Validation Error",
                text: "Total Cost must be greater than 0",
                visiblity: "show",
            });
            setTimeout(() => {
                setToaster({ visiblity: "hide" });
            }, 1500)
            return;
        }
        if (!subscriptionData.modeOfPayment) {
            setToaster({
                type: "danger",
                title: "Validation Error",
                text: "Mode of Payment is required",
                visiblity: "show",
            });
            setTimeout(() => {
                setToaster({ visiblity: "hide" });
            }, 1500)
            return;
        }

        // Convert dates to ISO format
        const payload = {
            startDate: new Date(subscriptionData.startDate).toISOString(),
            endDate: new Date(subscriptionData.endDate + 'T23:59:59.999Z').toISOString(),
            totalCost: parseFloat(subscriptionData.totalCost),
            modeOfPayment: subscriptionData.modeOfPayment,
            isActive: subscriptionData.isActive
        }

        setLoading(true)
        try {
            const response = await services.Vendor.UPDATE_VENDOR_SUBSCRIPTION(id, payload);
            console.log(response)
            setToaster({
                type: "success",
                title: "Subscription Updated",
                text: 'Subscription updated successfully',
                visiblity: "show",
            });
            setTimeout(() => {
                navigate('/subscriptions')
            }, 300)
        } catch (error) {
            console.log(error)
            setToaster({
                type: "danger",
                title: "Error Occured",
                text: error.response?.data?.message || "Failed to update subscription",
                visiblity: "show",
            });
            setTimeout(() => {
                setToaster({
                    visiblity: "hide",
                });
            }, 1500)
        } finally {
            setLoading(false)
        }
    }

    if (isMobileView) {
        if (fetching) {
            return (<main className="mlux" style={{ display: 'grid', placeItems: 'center', minHeight: '100vh' }}><div className="mlux-empty"><div className="ic"><i className="far fa-spinner"></i></div><h4>Loading…</h4></div></main>);
        }
        return (
            <>
                <Toaster type={toaster.type} title={toaster.title} text={toaster.text} visiblity={toaster.visiblity} />
                <SideBar />
                <main className="mlux mlux-auth">
                    <MobileHeader back={`/subscriptions/${id}`} />
                    <div className="mlux-greet" style={{ margin: '8px 4px 2px' }} data-rise="1">
                        <div className="kick">Update plan</div>
                        <div className="nm" style={{ fontSize: 22 }}>Edit Subscription</div>
                    </div>
                    <div className="mlux-card" style={{ padding: 16, marginTop: 12 }} data-rise="2">
                        <label className="mlux-lbl">Start date</label>
                        <div className="mlux-field"><i className="far fa-calendar"></i><input type="date" value={subscriptionData.startDate} onChange={(e) => HandleOnChangeValue(e.target.value, 'startDate')} /></div>
                        <label className="mlux-lbl">End date</label>
                        <div className="mlux-field"><i className="far fa-calendar-check"></i><input type="date" value={subscriptionData.endDate} onChange={(e) => HandleOnChangeValue(e.target.value, 'endDate')} /></div>
                        <label className="mlux-lbl">Total cost (₹)</label>
                        <div className="mlux-field no-icon"><input type="number" value={subscriptionData.totalCost} onChange={(e) => HandleOnChangeValue(e.target.value, 'totalCost')} /></div>
                        <label className="mlux-lbl">Payment mode</label>
                        <div className="mlux-field no-icon select"><select value={subscriptionData.modeOfPayment} onChange={(e) => HandleOnChangeValue(e.target.value, 'modeOfPayment')}><option value="">Select payment mode</option><option value="cash">Cash</option><option value="online">Online</option></select></div>
                        <label className="mlux-lbl">Status</label>
                        <div className="mlux-field no-icon select"><select value={subscriptionData.isActive ? 'true' : 'false'} onChange={(e) => HandleOnChangeValue(e.target.value === 'true', 'isActive')}><option value="true">Active</option><option value="false">Inactive</option></select></div>
                        <button className="mlux-btn" style={{ marginTop: 12 }} disabled={loading} onClick={onSubmitHandler}><i className="far fa-circle-check"></i> {loading ? 'Saving…' : 'Save changes'}</button>
                    </div>
                </main>
            </>
        );
    }

    if (fetching) {
        return (<>
            <Header />
            <SideBar />
            <main class="main">
                <div class="user-profile py-5">
                    <div class="container">
                        <div class="row">
                            <DashboardSideBar />
                            <div class="col-lg-9">
                                <div class="text-center py-5">
                                    <p>Loading subscription details...</p>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </main>
            <Footer />
        </>)
    }

    return (<>
        <Header />
        <SideBar />
        <main class="main">

            <Toaster
                type={toaster.type}
                title={toaster.title}
                text={toaster.text}
                visiblity={toaster.visiblity}
            />

            <div class="user-profile py-5">
                <div class="container">
                    <div class="row">
                        <DashboardSideBar />
                        <div class="col-lg-9">
                            <div class="user-profile-wrapper">
                                <div class="row">
                                    <div class="col-lg-12">
                                        <div class="user-profile-card">
                                            <div class="user-profile-card-header">
                                                <h4 class="user-profile-card-title">Edit Subscription</h4>
                                            </div>
                                            <div class="user-profile-form">

                                                <div class="row">
                                                    <div class="col-md-6">
                                                        <div class="form-group">
                                                            <label>Start Date <span class="text-danger">*</span></label>
                                                            <input
                                                                type="date"
                                                                onChange={(e) => HandleOnChangeValue(e.target.value, 'startDate')}
                                                                class="form-control"
                                                                value={subscriptionData.startDate}
                                                                placeholder="Start Date"
                                                                required
                                                            />
                                                            {!subscriptionData.startDate && <small className="text-danger">Start Date is required</small>}
                                                        </div>
                                                    </div>
                                                    <div class="col-md-6">
                                                        <div class="form-group">
                                                            <label>End Date <span class="text-danger">*</span></label>
                                                            <input
                                                                type="date"
                                                                onChange={(e) => HandleOnChangeValue(e.target.value, 'endDate')}
                                                                class="form-control"
                                                                value={subscriptionData.endDate}
                                                                placeholder="End Date"
                                                                required
                                                            />
                                                            {!subscriptionData.endDate && <small className="text-danger">End Date is required</small>}
                                                        </div>
                                                    </div>
                                                    <div class="col-md-6">
                                                        <div class="form-group">
                                                            <label>Total Cost (Rs.) <span class="text-danger">*</span></label>
                                                            <input
                                                                type="number"
                                                                step="0.01"
                                                                onChange={(e) => HandleOnChangeValue(e.target.value, 'totalCost')}
                                                                class="form-control"
                                                                value={subscriptionData.totalCost}
                                                                placeholder="Total Cost"
                                                                required
                                                            />
                                                            {(!subscriptionData.totalCost || subscriptionData.totalCost <= 0) && <small className="text-danger">Total Cost must be greater than 0</small>}
                                                        </div>
                                                    </div>
                                                    <div class="col-md-6">
                                                        <div class="form-group">
                                                            <label>Mode of Payment <span class="text-danger">*</span></label>
                                                            <select
                                                                onChange={(e) => HandleOnChangeValue(e.target.value, 'modeOfPayment')}
                                                                class="form-control"
                                                                value={subscriptionData.modeOfPayment}
                                                                required
                                                            >
                                                                <option value="">Select Payment Mode</option>
                                                               
                                                                <option value="online">Online</option>
                                                            </select>
                                                            {!subscriptionData.modeOfPayment && <small className="text-danger">Mode of Payment is required</small>}
                                                        </div>
                                                    </div>
                                                    <div class="col-md-6">
                                                        <div class="form-group">
                                                            <label>Status</label>
                                                            <select
                                                                onChange={(e) => HandleOnChangeValue(e.target.value === 'true', 'isActive')}
                                                                class="form-control"
                                                                value={subscriptionData.isActive ? 'true' : 'false'}
                                                            >
                                                                <option value="true">Active</option>
                                                                <option value="false">Inactive</option>
                                                            </select>
                                                        </div>
                                                    </div>
                                                </div>
                                                <div class="d-flex align-items-center gap-3">
                                                    <button
                                                        type="button"
                                                        onClick={onSubmitHandler}
                                                        class="theme-btn my-3"
                                                        disabled={loading}
                                                    >
                                                        <span class="far fa-save"></span> {loading ? 'Updating...' : 'Update Subscription'}
                                                    </button>
                                                    <Link to={'/subscriptions'} class="theme-btn my-3" style={{ background: '#6c757d' }}>
                                                        <span class="far fa-times"></span> Cancel
                                                    </Link>
                                                </div>

                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>

        </main>
        <Footer />
    </>
    )
}
export default EditSubscription

